import * as angular from "angular";
import { States } from "../../shared/config/constant.module";
import { apsEnums } from "../../shared/dto/aps.enums";
import { StateParams } from "../../common";
import template from "./checks.tpl.html";
import AuthDataServiceName, {
  AuthDataService,
} from "../../services/auth/authData.service";
let requires = [AuthDataServiceName];

function checksConfig($stateProvider: angular.ui.IStateProvider) {
  $stateProvider.state({
    name: States.CHECKS,
    url: "/checks",
    controller: "ChecksCtrl as vm",
    template: template,
    data: { pageTitle: "Checks", v2Uri: "aps/dashboard/operator/check-list" },
  });
}

class ChecksCtrl {
  isSupervisor: boolean;
  states: States;
  viewAll: boolean;

  constructor(authDataService: AuthDataService, $stateParams: StateParams) {
    this.isSupervisor =
      authDataService.isPlantAdmin($stateParams.plantId) ||
      authDataService.hasFlag(apsEnums.RoleFlags.ShiftSupervisor);
    this.viewAll = false;
  }
}

export default angular
  .module("aps.controller.checks", requires)
  .config(checksConfig)
  .controller("ChecksCtrl", ChecksCtrl).name;



// WEBPACK FOOTER //
// ./src/app/controllers/checks/checks.controller.ts